var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking-slide"},[_c('h3',{staticClass:"mx-auto font-sans font-medium text-center text-blue-500 h2",staticStyle:{"max-width":"250px"}},[_vm._v("\n        "+_vm._s(_vm.ui.review.heading)+"\n    ")]),_vm._v(" "),(_vm.ui.review.text)?_c('p',{staticClass:"mt-6 font-normal text-center text-blue-500"},[_vm._v("\n        "+_vm._s(_vm.ui.review.text)+"\n    ")]):_vm._e(),_vm._v(" "),_c('ReviewSection',{attrs:{"heading":"Appointment Service","fields":[
            {
                label: 'Appointment Type',
                data: _vm.serviceDisplayTitle
            },
            {
                label: 'New Patient',
                data: _vm.newPatient ? 'Yes' : 'No'
            }
        ]},on:{"edit":function($event){return _vm.$emit('step-to', 0)}}}),_vm._v(" "),_c('ReviewSection',{attrs:{"heading":"Appointment Location","fields":[
            {
                label: 'Appointment Location',
                data: _vm.location.locationName
            }
        ]},on:{"edit":function($event){return _vm.$emit('step-to', 1)}}}),_vm._v(" "),_c('ReviewSection',{attrs:{"heading":"Appointment Selection","fields":[
            {
                label: _vm.practitionerType,
                data: _vm.practitionerName
            },
            {
                label: 'Appointment Time & Date',
                data: _vm.appointmentDateTime
            }
        ]},on:{"edit":function($event){return _vm.$emit('step-to', 2)}}}),_vm._v(" "),_c('ReviewSection',{attrs:{"heading":"Your Details","fields":[
            {
                label: 'First name',
                data: _vm.details.firstName
            },
            {
                label: 'Last name',
                data: _vm.details.lastName
            },
            {
                label: 'Date of birth',
                data: _vm.details.dob
            },
            {
                label: 'Mobile number',
                data: _vm.details.phoneNumber
            },
            {
                label: 'Member number',
                data: _vm.details.membershipNumber
            },
            {
                label: 'Person number (see back of card)',
                data: _vm.details.hicapsCode
            }
        ]},on:{"edit":function($event){return _vm.$emit('step-to', 3)}}}),_vm._v(" "),(_vm.ui.review.disclaimer)?_c('p',{staticClass:"mt-8 small text-grey-500 sm:mt-14"},[_vm._v("\n        "+_vm._s(_vm.ui.review.disclaimer)+"\n    ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"w-full mt-10 btn",class:{
            'btn--loading text-blue-500': _vm.isLoading
        },on:{"click":_vm.submit}},[_vm._v("\n        Confirm & Submit\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }